// 全局状态管理
import { CQ } from "utils/commonQuest";

export const fileExport = {
    name: "fileExport",
    state: {
        // 导出进程
        exportProcess: {
            num: 0,
            status: null,
            file: null,
        },
    },
    reducers: {
        // 更新导出进程
        updateExportProcess(state, data: any) {
            return {
            ...state,
            exportProcess: { ...state.exportProcess, ...data }
            };
        },
        cleanExportState(state, data:any) {
            return {
                ...state,
                exportProcess: { 
                    num: 0,
                    status: null,
                    file: null, 
                }
            };
        }
    },
    effects: {
        async queryAndExport(payload: any, rootState: any){
            // let { fileExport } = rootState;
            // let { exportProcess } = fileExport;
            let { params, requestUrl } = payload;
            const result = await CQ(requestUrl(params), true);
            if(result.res.code == "0000" ){
                //已经准备完成
                this.updateExportProcess({
                    num: 100,
                    status: 'complete',
                    file: result.res.data.file
                })
            }else{
                let  data = result.res.data;
                this.updateExportProcess({
                    num: data.loading,
                    status: 'active',
                    file: data.file
                })
                this.queryAndExport({
                    params:{...params, file: data.file, page: params.page + 1},
                    requestUrl
                });
            }
        }
    }
}
